import React, {useEffect, useRef} from 'react';
import Chart, {ChartConfiguration} from "chart.js/auto";
import "../styles/GeneralChart.scss"
import {useCategories} from "../hooks/useCategory";
import {getGeneralAverage} from "../utils/getGeneralAverage";


export function GeneralChart() {
    const chartRef = useRef<HTMLCanvasElement | null>(null);
    const chartInstanceRef = useRef<Chart | null>(null);

    const { categories, isLoading } =  useCategories();

    useEffect(() => {

        if (chartRef.current && categories) {
            // Si un graphique existe déjà, on le détruit avant d'en créer un nouveau
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }

            // On filtre les catégories valides
            const filteredCategories = categories.filter(
                category => category.weighted_average !== -1
            );

            // On détruit l'ancien graphique s'il existe
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }

            // Création des données du graphique
            const data = {
                labels: filteredCategories.map(c => `${c.category} coeff:${c.coefficient}`), // noms des catégories
                datasets: [
                    {
                        label: 'Moyenne par matière',
                        data: filteredCategories.map(c => c.weighted_average),
                        fill: true,
                        backgroundColor: 'rgba(54, 162, 235, 0.2)',
                        borderColor: 'rgb(54, 162, 235)',
                        pointBackgroundColor: 'rgb(54, 162, 235)',
                        pointBorderColor: '#fff',
                        pointHoverBackgroundColor: '#fff',
                        pointHoverBorderColor: 'rgb(54, 162, 235)',
                        tension: 0.4
                    }
                ]
            };

            const config: ChartConfiguration<'radar', number[], string>  = {
                type: 'radar',
                data: data,
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    elements: {
                        line: {
                            borderWidth: 3
                        }
                    },
                    scales: {
                        r: {
                            min: 0,
                            max: 20,
                            ticks: {
                                stepSize: 5
                            },
                            pointLabels: {
                                font: {
                                    size: 14
                                }
                            }

                        }
                    }
                }
            };

            // Création du graphique
            chartInstanceRef.current = new Chart(chartRef.current, config);

            // Nettoyage à la destruction du composant
            return () => {
                if (chartInstanceRef.current) {
                    chartInstanceRef.current.destroy();
                }
            };
        }
    }, [categories]);

    if (isLoading || !categories) return (<div></div>);

    return (
        <>
            <h3 className={"flex-row justify-content-center"}>Moyenne Génarale: {getGeneralAverage(categories)}</h3>
            <canvas className="full-width-canvas" ref={chartRef}></canvas>
        </>

    );
}
